import {Controller} from "stimulus"
import {TimelineLite} from "gsap/TimelineLite"
import {TweenLite, Power4} from "gsap/TweenLite"

export default class extends Controller {

    static targets = [
    ]

    initialize() {


        this.mainColor = "#ff5100"

        this.colors = [
            "#ffe800",
            "#38d430",
            "#857550",
            "#ff40b4",
            "#dae343",
        ];

        this.$logo = this.element.querySelector(".header__logo")

        if ( this.$logo ) {

            this.$logoCross = this.$logo.querySelector(".logo-svg__cross")
            this.isHovering = false
            this.currentIndex = -1

            this.$logo.addEventListener("mouseover", () => {
                if ( this.isHovering ) {
                    return
                }
                this.currentIndex++
                this.isHovering = true
                if ( this.currentIndex > this.colors.length -1 ) {
                    this.currentIndex = 0
                }
                const color = this.colors[this.currentIndex]
                TweenLite.to(this.$logoCross, 0.6, {rotation: 180, fill: color, ease: Power4.easeInOut, transformOrigin: "center center"})
            })

            this.$logo.addEventListener("mouseleave", () => {
                TweenLite.to(this.$logoCross, 0.6, {rotation: 0, fill: this.mainColor, ease: Power4.easeInOut, transformOrigin: "center center"})
                this.isHovering = false
            })

        }

    }

    back(e){
        e.preventDefault()
        console.log("going back")
        history.back()
    }


}